import * as z from 'zod'

import type { MentionItem } from '@/components/stella/types'

export const MentionItemSchema = z.object({
  id: z.string(),
  displaySeq: z.string(),
  title: z.string(),
  meta: z.string(),
  type: z.enum(['idea', 'experiment', 'hypothesis', 'insight', 'artifact']),
  productId: z.string().optional(),
  productName: z.string().optional(),
}) satisfies z.ZodType<MentionItem>
